const NATIVE = typeof window !== "undefined" && window.ErimusNative;

export const isNativeApp = () => Boolean(NATIVE && NATIVE.platform === "native");
export const hasBiometricBridge = () => Boolean(NATIVE && NATIVE.biometrics);

export const hasSecureStoreBridge = () => Boolean(NATIVE && NATIVE.secureStore);

let counter = 0;

/** Envia uma mensagem para a casca nativa e aguarda a resposta correspondente. */
const request = (type, payload = {}, timeoutMs = 60000) =>
  new Promise((resolve) => {
    if (!isNativeApp()) {
      resolve(null);
      return;
    }
    const requestId = `req-${Date.now()}-${counter += 1}`;
    const timer = setTimeout(() => {
      window.removeEventListener("erimus-native", onEvent);
      resolve(null);
    }, timeoutMs);

    function onEvent(event) {
      let data;
      try {
        data = JSON.parse(event.data);
      } catch {
        return;
      }
      if (data.requestId !== requestId) return;
      clearTimeout(timer);
      window.removeEventListener("erimus-native", onEvent);
      resolve(data);
    }

    window.addEventListener("erimus-native", onEvent);
    NATIVE.send({ type, requestId, ...payload });
  });

export const hasPushBridge = () => Boolean(NATIVE && NATIVE.push);

/** Eventos espontâneos da casca nativa (token de push, toque na notificação). */
export const onNativeEvent = (type, handler) => {
  const onEvent = (event) => {
    let data;
    try {
      data = JSON.parse(event.data);
    } catch {
      return;
    }
    if (data.type === type && !data.requestId) handler(data);
  };
  window.addEventListener("erimus-native", onEvent);
  return () => window.removeEventListener("erimus-native", onEvent);
};

export const push = {
  status: () => request("push:status", {}, 10000),
  enable: () => request("push:enable", {}, 60000),
};

export const biometrics = {
  status: () => request("biometrics:status"),
  set: (enabled) => request("biometrics:set", { enabled }),
  lockNow: () => request("biometrics:lock", {}, 5000),
};

/** Guarda a chave anônima no armazenamento seguro do aparelho, protegida por biometria. */
export const secretVault = {
  has: () => request("secret:has", {}, 5000),
  save: (value) => request("secret:save", { value }),
  get: () => request("secret:get"),
  remove: () => request("secret:remove", {}, 10000),
};
